module.exports = __webpack_public_path__ + "media/app/assets/races/orc_female-d8605993dd88aa4e8be295dd1440c8a8.png";